/* POA / CHROME MONOLITH
   Raymarched liquid-chrome SDF. No libraries, no CDN, no build step.

   PERFORMANCE CONTRACT — this effect is fill-rate bound, so cost scales with
   PIXELS, not with the size of the form. Three rules keep it honest:
     1. The drawing buffer is hard-capped at MAX_W px wide and never multiplied
        by devicePixelRatio. CSS upscales it. Chrome is low-frequency — the
        upscale is invisible, the saving is not.
     2. Frame time is measured. If the device is struggling the buffer is cut,
        then cut again, then the effect gives up and shows the static mark.
     3. Nothing runs offscreen, on a hidden tab, or under reduced-motion.

   Degrades to the static shield mark whenever WebGL is unavailable, the
   shader fails to build, or the device can't hold a usable frame rate. */
(function () {
  var hosts = document.querySelectorAll('[data-poa-chrome]');
  if (!hosts.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var MAX_W = 720;   // hard ceiling on drawing-buffer width, in real pixels
  var STEPS = 48;    // raymarch iterations

  var VERT = [
    'attribute vec2 a_pos;',
    'void main(){ gl_Position = vec4(a_pos, 0.0, 1.0); }'
  ].join('\n');

  var FRAG = [
    'precision mediump float;',
    'uniform vec2  u_res;',
    'uniform float u_time;',
    'uniform vec2  u_mouse;',
    'uniform float u_scroll;',
    'uniform vec3  u_ember;',

    'mat2 rot(float a){ float c=cos(a), s=sin(a); return mat2(c,-s,s,c); }',

    'float smin(float a, float b, float k){',
    '  float h = clamp(0.5 + 0.5*(b-a)/k, 0.0, 1.0);',
    '  return mix(b, a, h) - k*h*(1.0-h);',
    '}',

    'float sdRoundBox(vec3 p, vec3 b, float r){',
    '  vec3 q = abs(p) - b;',
    '  return length(max(q, 0.0)) + min(max(q.x, max(q.y, q.z)), 0.0) - r;',
    '}',

    /* the form: a struck slab that molten mass fuses back into */
    'float map(vec3 p){',
    '  vec3 q = p;',
    '  q.xz *= rot(u_time * 0.17 + u_mouse.x * 0.55);',
    '  q.yz *= rot(sin(u_time * 0.13) * 0.20 + u_mouse.y * 0.32);',
    '  float d = sdRoundBox(q, vec3(0.46, 0.70, 0.19), 0.30);',
    '  d += 0.036 * sin(4.3*q.x + u_time*0.70)',
    '             * sin(3.6*q.y - u_time*0.55)',
    '             * sin(4.0*q.z + u_time*0.40);',
    '  vec3 o1 = vec3(0.78*sin(u_time*0.47), 0.50*cos(u_time*0.39), 0.42*sin(u_time*0.31));',
    '  d = smin(d, length(p - o1) - 0.26, 0.52);',
    '  vec3 o2 = vec3(-0.70*sin(u_time*0.29), -0.62*cos(u_time*0.34), -0.38*cos(u_time*0.26));',
    '  d = smin(d, length(p - o2) - 0.20, 0.46);',
    '  return d;',
    '}',

    'vec3 calcNormal(vec3 p){',
    '  vec2 e = vec2(0.0018, 0.0);',
    '  return normalize(vec3(',
    '    map(p+e.xyy) - map(p-e.xyy),',
    '    map(p+e.yxy) - map(p-e.yxy),',
    '    map(p+e.yyx) - map(p-e.yyx)));',
    '}',

    /* procedural studio environment — this is what reads as polished chrome */
    'vec3 env(vec3 rd){',
    '  float y = rd.y;',
    '  vec3 c = mix(vec3(0.020,0.021,0.026), vec3(0.66,0.68,0.72), smoothstep(-0.30, 0.75, y));',
    '  c += vec3(1.0,0.99,0.96) * exp(-abs(y - 0.05) * 26.0) * 0.90;',
    '  c += vec3(0.85,0.88,0.95) * pow(max(y, 0.0), 6.0) * 0.55;',
    '  c += u_ember * smoothstep(0.05, -0.55, y) * 0.42;',
    '  c *= 1.0 + 0.06 * sin(atan(rd.z, rd.x) * 18.0);',
    '  return c;',
    '}',

    'void main(){',
    '  vec2 uv = (gl_FragCoord.xy - 0.5*u_res) / u_res.y;',
    '  vec3 ro = vec3(0.0, 0.0, 3.05);',
    '  vec3 rd = normalize(vec3(uv, -1.45));',

    '  float t = 0.0;',
    '  float hit = 0.0;',
    '  for (int i = 0; i < ' + STEPS + '; i++){',
    '    vec3 p = ro + rd * t;',
    '    float d = map(p);',
    '    if (d < 0.0022){ hit = 1.0; break; }',
    '    t += d * 0.92;',
    '    if (t > 6.0) break;',
    '  }',

    '  vec3 col = vec3(0.0);',
    '  if (hit > 0.5){',
    '    vec3 p = ro + rd * t;',
    '    vec3 n = calcNormal(p);',
    '    vec3 r = reflect(rd, n);',
    '    float fres = pow(1.0 - max(dot(n, -rd), 0.0), 4.0);',
    '    col  = env(r) * 0.92;',
    '    col += vec3(1.0) * fres * 0.55;',
    '    vec3 L = normalize(vec3(0.35, 0.75, 0.55));',
    '    col += vec3(1.0,0.98,0.94) * pow(max(dot(r, L), 0.0), 46.0) * 0.85;',
    '    col += u_ember * pow(max(-n.y, 0.0), 2.2) * 0.30;',
    '    col *= 0.82 + 0.18 * smoothstep(0.0, 1.2, p.y + 1.0);',
    '  }',

    '  float vig = smoothstep(1.35, 0.28, length(uv));',
    '  col *= vig;',
    '  float g = fract(sin(dot(gl_FragCoord.xy, vec2(12.9898, 78.233)) + u_time) * 43758.5453);',
    '  col += (g - 0.5) * 0.020;',
    '  col *= 1.0 - clamp(u_scroll, 0.0, 1.0);',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'
  ].join('\n');

  function compile(gl, type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
      console.warn('POA chrome shader:', gl.getShaderInfoLog(s));
      return null;
    }
    return s;
  }

  function hexToRgb(hex, fallback) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
    if (!m) return fallback;
    return [parseInt(m[1], 16) / 255, parseInt(m[2], 16) / 255, parseInt(m[3], 16) / 255];
  }

  function boot(canvas) {
    var host = canvas.closest('.chrome-monolith') || canvas.parentNode;

    function giveUp() { host.classList.remove('chrome-live'); host.classList.add('chrome-static'); }

    if (reduced) { giveUp(); return; }

    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, depth: false, stencil: false })
          || canvas.getContext('experimental-webgl');
    if (!gl) { giveUp(); return; }

    var vs = compile(gl, gl.VERTEX_SHADER, VERT);
    var fs = compile(gl, gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) { giveUp(); return; }

    var prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
      console.warn('POA chrome link:', gl.getProgramInfoLog(prog));
      giveUp();
      return;
    }
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a_pos');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uRes    = gl.getUniformLocation(prog, 'u_res');
    var uTime   = gl.getUniformLocation(prog, 'u_time');
    var uMouse  = gl.getUniformLocation(prog, 'u_mouse');
    var uScroll = gl.getUniformLocation(prog, 'u_scroll');
    var uEmber  = gl.getUniformLocation(prog, 'u_ember');

    var ember = hexToRgb(canvas.getAttribute('data-ember'), [0.760, 0.204, 0.102]);
    gl.uniform3f(uEmber, ember[0], ember[1], ember[2]);

    /* quality is a multiplier on the already-capped buffer width. It only
       ever goes down, and only in response to measured frame time. */
    var quality = 1.0;

    function resize() {
      var cssW = canvas.clientWidth || 1;
      var cssH = canvas.clientHeight || 1;
      var targetW = Math.min(cssW, MAX_W) * quality;
      var ratio = targetW / cssW;
      var pw = Math.max(1, Math.round(cssW * ratio));
      var ph = Math.max(1, Math.round(cssH * ratio));
      if (canvas.width !== pw || canvas.height !== ph) {
        canvas.width = pw;
        canvas.height = ph;
        gl.viewport(0, 0, pw, ph);
      }
      gl.uniform2f(uRes, canvas.width, canvas.height);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resize, 150);
    }, { passive: true });
    resize();

    var mx = 0, my = 0, tx = 0, ty = 0;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      window.addEventListener('mousemove', function (e) {
        tx = (e.clientX / window.innerWidth - 0.5) * 2;
        ty = (e.clientY / window.innerHeight - 0.5) * 2;
      }, { passive: true });
    }

    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) raf();
      }, { threshold: 0.01 }).observe(canvas);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && visible) raf();
    });

    var start = performance.now();
    var running = false;
    var last = start;
    var acc = 0, frames = 0, downshifts = 0;

    function frame(now) {
      if (!visible || document.hidden) { running = false; return; }
      running = true;

      /* Measure in windows of 40 frames. Two strikes and the effect retires
         rather than sitting there stuttering on someone's laptop. */
      var dt = now - last;
      last = now;
      if (dt > 0 && dt < 500) { acc += dt; frames++; }
      if (frames >= 40) {
        var avg = acc / frames;
        acc = 0; frames = 0;
        if (avg > 30) {
          downshifts++;
          if (downshifts > 2) { running = false; giveUp(); return; }
          quality *= 0.68;
          resize();
        }
      }

      // ease the pointer so the metal feels heavy, never twitchy
      mx += (tx - mx) * 0.045;
      my += (ty - my) * 0.045;

      var r = host.getBoundingClientRect();
      var progress = r.height > 0 ? Math.max(0, Math.min(1, -r.top / r.height)) : 0;

      gl.uniform1f(uTime, (now - start) / 1000);
      gl.uniform2f(uMouse, mx, my);
      gl.uniform1f(uScroll, progress * 1.15);
      gl.drawArrays(gl.TRIANGLES, 0, 3);

      requestAnimationFrame(frame);
    }

    function raf() { if (!running) requestAnimationFrame(frame); }

    canvas.addEventListener('webglcontextlost', function (e) {
      e.preventDefault();
      running = false;
      giveUp();
    });

    host.classList.add('chrome-live');
    raf();
  }

  Array.prototype.forEach.call(hosts, boot);
})();
